<!-- 

PARAMETRO options: [ { id: '', text: '' } ]

-->

<template>
    <div :class="typeaheadState">
        <!-- <div class="typeahead__toggle" ref="toggle" @mousedown.prevent="toggle" :style="fontSize"> -->
        <div class="typeahead__toggle" ref="toggle" @mousedown.prevent="toggle" :style="fontSize">
            
            <!-- <input type="text" class="typeahead__search" ref="search" -->
            <input type="text" class="form-control form-control-sm typeahead__search" style="text-transform:uppercase" ref="search"
                v-model="search"
                @focus="onFocus"
                @blur="onBlur"
                @keydown.esc="onEscape"
                @keydown.down="onDownKey"
                @keydown.up="onUpKey"
                @keydown.enter="onEnterKey"
                @keyup="onChangeSearch"
                autocomplete="off"
                >
            <span class="typeahead__text" ref="text">{{displayText}}</span>
        </div>
        <!-- <ul class="typeahead__list" ref="list" :style="listWidth" v-if="open"> -->
        <ul class="ta-list list-group shadow" ref="list" :style="listWidth" v-if="open">
            <li class="typeahead__item" v-for="(option, index) in filteredOptions" :key="index">
                <a class="typeahead__link" @mousedown.prevent="select(option)"
                    :class="[selectIndex === index ? 'typeahead__active':'']"
                    >
                    {{option.text}}
                </a>
            </li>
        </ul>
    </div>
</template>
<script type="text/javascript">
import { SysVars } from '../main'
import { apiORDS } from '../shared/api-functions'

    export default {
        props: {
            // options: {
            //     type: Array,
            //     default() {
            //         return []
            //     }
            // },
            value: {
                type: [String, Number],
                default: null
            },
            entity: {
                type: String, 
                default: null, 
                required: false
            }
        },
        data() {
            return {
                open: false,
                selectIndex: 0,
                displayText: '',
                search: '',
                listWidth: '',
                fontSize: '',
                keytimer: null,
                options: [],
            }
        },
        computed: {
            typeaheadState() {
                return this.open ? 'typeahead typeahead__open' : 'typeahead'
            },
            filteredOptions() {
                const exp = new RegExp(this.search, 'i')
                return this.options.filter((option) => {
                    return ( exp.test(option.id) || exp.test(option.text))
                })
            }
        },
        methods: {
            onDownKey() {
                if(this.filteredOptions.length -1 > this.selectIndex) {
                    this.selectIndex++
                    // scroll when overflow
                    if(this.selectIndex > 2) {
                        this.$refs.list.scrollTop += (20 + this.selectIndex)
                    }
                }
            },
            onUpKey() {
                if(this.selectIndex > 0) {
                    this.selectIndex--
                    // scroll when overflow
                    if(this.selectIndex > 0) {
                        this.$refs.list.scrollTop -= (20 + this.selectIndex)
                    }
                }
            },
            onEnterKey() {
                const option = this.filteredOptions[this.selectIndex]
                if(option) {
                    this.select(option)
                }
                var thisIndex = jQuery(this.$el.querySelector('input')).index(SysVars.sFocusControl)
                var next = thisIndex + 1
                jQuery(SysVars.sFocusControl).eq(next).focus()
            },
            select(option) {
                this.displayText = option.text,
                this.$emit('input', (option.id))
                this.onBlur()
                //this.$refs.search.blur()
                //console.log(option.id)
            },
            toggle(e) {
                if(e.target === this.$refs.toggle ||
                    e.target === this.$refs.search ||
                    e.target === this.$refs.text) {
                    if(this.open) {
                        if(e.target !== this.$refs.search &&
                            e.target !== this.$refs.text) {
                            this.$refs.search.blur()
                        }
                    } else {
                        this.$refs.search.focus()
                    }
                }
            },
            onFocus() {
                // this.open = true
            },
            onBlur() {
                this.search = ''
                this.selectIndex = 0
                if (this.open) {
                    this.$refs.list.scrollTop = 0
                }
                this.open = false
            },
            onEscape() {
                this.open = false
                // this.$refs.search.blur()
            },

            onChangeSearch(ev) {
                // console.log('onkeyup: ' + ev.keyCode)

                if (ev.keyCode == 40 || ev.keyCode == 38) {
                    return
                }

                this.open = true
                let vm = this
                if (this.keytimer){
                    clearTimeout(this.keytimer);
                }
                this.keytimer = setTimeout(function(){
                    vm.fillOptions()
                }, 200);
            },

            async fillOptions () {
                if (this.search.trim() == '') {
                    return
                }
                let url = this.$store.getters.urlOrdsSelect + this.entity + 
                '/?q={"value":{"$or":[{"$like":"%25' + this.search.toUpperCase() + '%25"},{"id":{"$like":"%25' + this.search.toUpperCase() + '%25"}}]}}'
                const data = await apiORDS(url)
                if (data.items) {
                    this.options = jQuery.map(data.items, function (item) {
                        return {
                            text: item.value,
                            id: item.id
                        }
                    })
                }
            },

            resizeList(el) {
                const rect = el.getBoundingClientRect()
                //const listStyle = this.$refs.list.$el.style
                this.listWidth = { width: rect.width + 'px' }
                // this.fontSize = { "font-size": el.style['font-size'] }
            },

        },

        created () {

        },

        mounted () {
            this.resizeList(this.$refs.search)            
            // console.log(this.$refs.search.style)
        }
    }
</script>
<style type="text/css" scoped>
    .ta-list {
        padding-top: 5px;
        position: absolute;
        max-height: 350px;
        overflow-y: auto;
        z-index: 999;
        background-clip: border-box;
        background-color: #fff;
        border: 1px solid rgba(0,0,0,.125);
        border-radius: .25rem;
    }


    .typeahead {
        /* border-radius: 3px; */
        /* border: 1px solid #ccc; */
        /* position: relative; */
        /* z-index: 1; */
        /* width: 100%; */
        /* font-size: 14px; */
    }
    .typeahead__open {
        border: 1px solid #41B883;
    }
    .typeahead__open .typeahead__text {
        color: #999;
        opacity: 0.4;
    }
    .typeahead__toggle {
        position: relative;
        z-index: 1;
        width: 100%;
    }
    .typeahead__search {
        position: absolute;
        /* top: 0; */
        /* left: 0; */
        /* line-height: 1em; */
        /* font-size: 1em; */
        padding: 5px;
        width: 100%;
        display: block;
        cursor: text;
        background: transparent;
        /* border: none; */
        /* outline: none; */
        z-index: 2;
    }
    .typeahead__text {
        min-height: 30px;
        /* font-size: 1em; */
        /* line-height: 1em; */
        padding: 5px;
        display: inline-block;
        position: relative;
        z-index: 3;
    }
    .typeahead__list {
        margin: 0;
        padding: 0;
        overflow-y: scroll;
        max-height: 200px;
        position: absolute;
        z-index: 999;
        overflow-y: auto;
        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
        -webkit-box-direction: normal;
        -webkit-box-orient: vertical;        
        background-clip: border-box;
        background-color: #fff;
        border: 1px solid rgba(0,0,0,.125);
        border-radius: .25rem;
    }
    .typeahead__item {
        display: block;
        border-top: 1px solid #f4f4f4;
    }
    .typeahead__link {
        display: block;
        padding: 10px;
        line-height: 1em;
        font-size: 1em;
        cursor: pointer;
    }
    .typeahead__active {
        background: blue;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/input-typeahead.vue